import { useState, useEffect } from "react";
import { fetchSearchResults } from "src/services/search";

const useSpecialHomeSlider = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let isMounted = true;
		setLoading(true);

		fetchSearchResults({
			rows: 10,
			params: {
				fair_active: true,
				random_order: true,
			},
			page: 1,
			source: 1,
		})
			.then(response => {
				if (isMounted) {
					const results =
						"searchFast" in response ? response.searchFast.data : response.data;
					setData(results || []);
					setLoading(false);
				}
			})
			.catch(err => {
				if (isMounted) {
					setError(err);
					setLoading(false);
				}
			});

		return () => {
			isMounted = false;
		};
	}, []);

	return {
		loading,
		data,
		error,
		hasProperties: !!data.length,
	};
};

export { useSpecialHomeSlider };

